import { initializeApp } from 'firebase/app';
import { getMessaging, isSupported } from 'firebase/messaging';
import type { Messaging } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: 'AIzaSyD_YWpQMW0o2w0aWdCfX9nnNY1Jlzfg1qk',
  authDomain: 'restro360-app-fcm.firebaseapp.com',
  projectId: 'restro360-app-fcm',
  storageBucket: 'restro360-app-fcm.firebasestorage.app',
  messagingSenderId: '102031986042',
  appId: '1:102031986042:web:7c2eb14f06f2148cf0dac3',
};

export const firebaseApp = initializeApp(firebaseConfig);

// Lazily resolved — avoids module-load crash in unsupported environments
let _messaging: Messaging | null = null;

export async function getFirebaseMessaging(): Promise<Messaging | null> {
  if (_messaging) return _messaging;
  try {
    const supported = await isSupported();
    if (!supported) {
      console.warn('[FCM] Firebase Messaging not supported in this browser');
      return null;
    }
    _messaging = getMessaging(firebaseApp);
    return _messaging;
  } catch (e) {
    console.warn('[FCM] getMessaging failed:', e);
    return null;
  }
}
